import type { ReactNode } from 'react';

/** `.hp-table` — 60 px rows, uppercase header, tabular numerals. */
export function BrutTable({ className, children }: { className?: string; children: ReactNode }) {
  return <table className={className ? `hp-table ${className}` : 'hp-table'}>{children}</table>;
}

/** Standard thead row. */
export function BrutTheadRow({ children }: { children: ReactNode }) {
  return (
    <thead>
      <tr>{children}</tr>
    </thead>
  );
}
